import React from "react";
const maskBlocks = {
    yyyy: { from: 1000, to: 9999 },
    MM: { from: 1, to: 12 },
    dd: { from: 1, to: 31 },
    HH: { from: 0, to: 23 },
    mm: { from: 0, to: 59 },
    ss: { from: 0, to: 59 },
    SSS: { from: 0, to: 999 }
};
const arrowKeys = {
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40
};
export class MaskedInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.checkPattern = (pattern, key, pos) => {
            switch (pattern[pos]) {
                case "0":
                    const numVal = parseInt(key);
                    if (!(numVal >= 0 && numVal <= 9)) {
                        return false;
                    }
                    return true;
                case "a":
                    const charVal = key;
                    if (charVal.toLowerCase() === charVal.toUpperCase()) {
                        return false;
                    }
                    return true;
                case "+":
                    if (key !== "+" && key !== "-")
                        return false;
                    return true;
                case "*":
                    return true;
                default:
                    const blockVal = parseInt(key);
                    let block = "";
                    for (let b = 0; b < Object.keys(maskBlocks).length; b++) {
                        block = Object.keys(maskBlocks)[b];
                        if (maskBlocks.hasOwnProperty(block) &&
                            block.indexOf(pattern[pos]) != -1) {
                            for (let i = 1; i <= block.length; i++) {
                                if (pattern[pos + i] != pattern[pos]) {
                                    if (i == block.length) {
                                        const blockFrom = maskBlocks[block].from.toString();
                                        const blockTo = maskBlocks[block].to.toString();
                                        const fromVal = parseInt(blockFrom[0]);
                                        const toVal = parseInt(blockTo[0]);
                                        if (blockTo.length == blockFrom.length) {
                                            return blockVal >= fromVal && blockVal <= toVal;
                                        }
                                        else {
                                            return blockVal >= 0 && blockVal <= toVal;
                                        }
                                    }
                                    else if (blockVal >= 0 && blockVal <= 9) {
                                        return true;
                                    }
                                    else {
                                        return false;
                                    }
                                }
                            }
                        }
                    }
                    return false;
            }
        };
        this.checkPlaceHolder = (pattern, pos) => {
            switch (pattern[pos]) {
                case "/":
                case "-":
                case ":":
                case ".":
                case ",":
                    return true;
                default:
                    return false;
            }
        };
        this.handleChange = (e) => {
            const input = this.inputBeingMasked.current;
            this.selection = {
                start: input.selectionStart,
                end: input.selectionEnd
            };
            this.props.onChange(e.target.value);
        };
        this.handlePaste = (e) => {
            const event = e || window.event;
            let pastedText = e.clipboardData.getData("Text");
            let { pattern, placeholderChar } = this.props;
            event.preventDefault();
            pastedText = this.maskValue(pastedText, pattern, placeholderChar);
            this.props.onChange(pastedText);
        };
        this.handleClick = () => {
            this.selection.start = this.inputBeingMasked.current.selectionStart;
            this.selection.end = this.inputBeingMasked.current.selectionStart;
            this.props.onClick();
        };
        this.handleKeyDown = (inputText) => (e) => {
            const backspaceKey = 8;
            const deleteKey = 46;
            const event = e || window.event;
            if (event && !this.props.disabled && !this.props.readOnly) {
                if (event.preventDefault) {
                    const element = event.target;
                    let start = element.selectionStart;
                    let end = element.selectionEnd;
                    let selectionStart = start;
                    let selectionEnd = start;
                    const key = event.keyCode;
                    if (key >= 37 && key <= 40) {
                        switch (key) {
                            case arrowKeys.LEFT:
                                this.selection.start =
                                    this.selection.start !== false ? this.selection.start - 1 : 0;
                                this.selection.end = this.selection.start;
                                break;
                            case arrowKeys.RIGHT:
                                this.selection.start =
                                    this.selection.start !== false ? this.selection.start + 1 : 0;
                                this.selection.end = this.selection.start;
                                break;
                            case arrowKeys.UP:
                                this.selection.start = 0;
                                this.selection.end = 0;
                                break;
                            case arrowKeys.DOWN:
                                this.selection.start = -1;
                                this.selection.end = -1;
                                break;
                        }
                    }
                    if (key == backspaceKey || key == deleteKey) {
                        event.preventDefault();
                        if (start != end) {
                            if (start > end) {
                                let aux = end;
                                end = start;
                                start = aux;
                            }
                            start++;
                            const substitute = this.props.placeholderChar.repeat(end - start + 1);
                            let substitutedText = inputText.substring(0, start - 1) +
                                substitute +
                                inputText.substring(end);
                            for (let i = start; i < end; i++) {
                                if (this.isCharPatternStatic(inputText[i], i)) {
                                    substitutedText = this.replaceCharAt(substitutedText, inputText[i], i);
                                }
                            }
                            inputText = substitutedText;
                            selectionStart = start - 1;
                            selectionEnd = start - 1;
                        }
                        else if (key == backspaceKey) {
                            if (start != 0) {
                                if (!this.isCharPatternStatic(inputText[start - 1], start - 1) &&
                                    inputText[start - 1] !== this.props.placeholderChar) {
                                    inputText =
                                        inputText.substring(0, start - 1) +
                                            this.props.placeholderChar +
                                            inputText.substring(end);
                                }
                                else {
                                    this.inputBeingMasked.current.selectionStart =
                                        this.selection.end !== false ? this.selection.end - 1 : 0;
                                    this.inputBeingMasked.current.selectionEnd =
                                        this.selection.end !== false ? this.selection.end - 1 : 0;
                                }
                                selectionStart = end - 1;
                                selectionEnd = end - 1;
                            }
                        }
                        else if (key == deleteKey) {
                            if (start != inputText.length) {
                                if (!this.isCharPatternStatic(inputText[start], start) &&
                                    inputText[start] !== this.props.placeholderChar) {
                                    inputText =
                                        inputText.substring(0, start) +
                                            this.props.placeholderChar +
                                            inputText.substring(end + 1);
                                }
                                else {
                                    this.inputBeingMasked.current.selectionStart =
                                        this.selection.end !== false ? this.selection.end + 1 : 1;
                                    this.inputBeingMasked.current.selectionEnd =
                                        this.selection.end !== false ? this.selection.end + 1 : 1;
                                }
                                selectionStart = end + 1;
                                selectionEnd = end + 1;
                            }
                        }
                        this.props.onChange(inputText);
                        this.selection.start = selectionStart;
                        this.selection.end = selectionEnd;
                    }
                }
                else {
                    event.returnValue = false;
                }
            }
        };
        this.handleKeyPress = (inputText) => (e) => {
            const event = e || window.event;
            const pattern = this.props.pattern;
            if (event && !this.props.disabled && !this.props.readOnly) {
                if (event.preventDefault) {
                    event.preventDefault();
                    const element = event.target;
                    const key = e.key;
                    let selectionStart = 0;
                    let selectionEnd = 0;
                    let start = element.selectionStart;
                    let end = element.selectionEnd;
                    if (start > end) {
                        let aux = end;
                        end = start;
                        start = aux;
                    }
                    if (this.checkPattern(pattern, key, start) &&
                        key !== inputText[start]) {
                        if (start != end) {
                            start++;
                            const substitute = key + this.props.placeholderChar.repeat(end - start);
                            let substitutedText = inputText.substring(0, start - 1) +
                                substitute +
                                inputText.substring(end);
                            for (let i = start; i < end; i++) {
                                if (this.isCharPatternStatic(inputText[i], i)) {
                                    substitutedText = this.replaceCharAt(substitutedText, inputText[i], i);
                                }
                            }
                            inputText = substitutedText;
                            this.props.onChange(inputText);
                            selectionStart = start;
                            selectionEnd = start;
                        }
                        else {
                            inputText =
                                inputText.substring(0, start) +
                                    key +
                                    inputText.substring(end + 1);
                            selectionStart = end + 1;
                            selectionEnd = end + 1;
                        }
                        this.props.onChange(inputText);
                        this.selection.start = selectionStart;
                        this.selection.end = selectionEnd;
                    }
                    else {
                        if (this.checkPlaceHolder(pattern, start)) {
                            if (this.checkPattern(pattern, key, start + 1)) {
                                inputText =
                                    inputText.substring(0, start + 1) +
                                        key +
                                        inputText.substring(end + 2);
                            }
                            this.selection.start = end + 2;
                            this.selection.end = end + 2;
                            this.props.onChange(inputText);
                        }
                        else {
                            this.selection.start = start !== false ? start + 1 : 1;
                            this.selection.end = start !== false ? start + 1 : 1;
                            this.inputBeingMasked.current.selectionStart =
                                start !== false ? start + 1 : 1;
                            this.inputBeingMasked.current.selectionEnd =
                                start !== false ? start + 1 : 1;
                        }
                    }
                }
                else {
                    event.returnValue = false;
                }
            }
        };
        this.inputBeingMasked = React.createRef();
        this.selection = {
            start: false,
            end: false
        };
    }
    componentDidUpdate() {
        const { selectionStart, selectionEnd } = this.inputBeingMasked.current;
        const update = (this.selection.start !== false &&
            this.selection.start !== selectionStart) ||
            (this.selection.end !== false && this.selection.end !== selectionEnd);
        if (update) {
            this.inputBeingMasked.current.selectionStart =
                this.selection.start !== false ? this.selection.start : 0;
            this.inputBeingMasked.current.selectionEnd =
                this.selection.end !== false ? this.selection.end : 0;
        }
    }
    replaceCharAt(str, replacement, pos) {
        const newStr = str.substring(0, pos) +
            replacement +
            str.substring(pos + replacement.length);
        return newStr;
    }
    isCharPatternStatic(char, pos) {
        if (this.props.pattern[pos] === char) {
            if (char == "0" ||
                char == "a" ||
                char == "*" ||
                char == "+" ||
                char == this.props.placeholderChar) {
                return false;
            }
            else {
                const blocks = Object.keys(maskBlocks);
                for (let b = 0; b < blocks.length; b++) {
                    if (blocks[b].indexOf(char) != -1) {
                        return false;
                    }
                }
            }
            return true;
        }
        return false;
    }
    maskValue(value, pattern, placeholderChar) {
        let returnValue = value;
        if (returnValue.length > pattern.length) {
            returnValue = returnValue.substring(0, pattern.length);
        }
        for (let i = 0; i < pattern.length; i++) {
            if (this.isCharPatternStatic(pattern[i], i)) {
                if (returnValue.length <= i) {
                    returnValue = returnValue + pattern[i];
                }
                else {
                    returnValue = this.replaceCharAt(returnValue, pattern[i], i);
                }
            }
            else {
                if (returnValue.length <= i) {
                    returnValue = returnValue + placeholderChar;
                }
                else {
                    if (!this.checkPattern(pattern, returnValue[i], i)) {
                        returnValue = this.replaceCharAt(returnValue, placeholderChar, i);
                    }
                }
            }
        }
        return returnValue;
    }
    render() {
        const { value, pattern, placeholderChar, children, className, disabled, readOnly } = this.props;
        const maskedValue = typeof value !== "undefined"
            ? this.maskValue(value.toString(), pattern, placeholderChar)
            : "";
        const maskedChildren = React.cloneElement(children, {
            value: maskedValue,
            formdata: maskedValue,
            className: className,
            disabled: disabled,
            readOnly: readOnly,
            ref: this.inputBeingMasked,
            onChange: this.handleChange,
            onClick: this.handleClick,
            onPaste: this.handlePaste,
            onKeyPress: this.handleKeyPress(maskedValue),
            onKeyDown: this.handleKeyDown(maskedValue)
        });
        return maskedChildren;
    }
}
//# sourceMappingURL=MaskedInput.js.map